import app from '@wtdc/feed';
import models from '@/models';
import Container from '@/routes';

import 'antd-mobile-v2/dist/antd-mobile.css';
import '@/assets/sass/app.scss';

app
  .useHistory()
  .useRedux(models)  //注入路由
  .useRouter(Container)
  .attach(document.getElementById('App')); //渲染界面

if(module.hot) {
  (module).hot.accept('./routes', () => {
    window.location.href = location.href;
  });
}

export default app;
